'use client';

import { LinkButtonPrimitive, LinkPrimitive } from '@stadium/ui/client';
import type {
  LinkButtonPrimitiveProps,
  LinkPrimitiveProps,
} from '@stadium/ui/client';
import NextLink from 'next/link';

type LinkProps = LinkPrimitiveProps<typeof NextLink>;

export function Link(props: LinkProps) {
  return <LinkPrimitive component={NextLink} {...props} />;
}

type LinkButtonProps = LinkButtonPrimitiveProps<typeof NextLink>;
export function LinkButton(props: LinkButtonProps) {
  return <LinkButtonPrimitive component={NextLink} {...props} />;
}
